import * as React from "react";
import {FormComponentProps, FieldSet, KeyValue, ListItemFieldSet, ValidationResult, FieldSetStatus} from "./Form";
import {FormUtils} from "./FormUtils";
import * as _ from "lodash";
import {FormElement} from "./FormInput";


interface FormListProps extends React.HTMLProps<HTMLElement>, FormComponentProps {
    children?: React.ReactChildren;
    model: string;
    key?: string;
}

/**
 * IN PROGRESS DO NOT USE YET!
 */
export class FormList extends React.Component<FormListProps, {}> {


    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (typeof this.getModelValue() == "undefined") {
            this.props.fieldSet.updateModel(this.props.model, null, true, {errorName: null, pristine: true});
        }
    }

    getModelValue() {
        return this.props.fieldSet.getModelValue(this.props.model);
    }

    updateEntry(index: number, model: string, value: any, pristine: boolean, validationResult: ValidationResult) {
        if (!model) {
            console.warn("Attribute model not set in list item FormComponent");
        }
        this.props.fieldSet.updateModel(this.getListItemModel(index, model), value, true, validationResult);
    }

    updateEntries(index: number, values: KeyValue<any>[]) {
        values.forEach(kvp => {
            kvp.key = this.getListItemModel(index, kvp.key);
        });
        this.props.fieldSet.updateModels(values);
    }

    getListItemModel(index: number, model: string) {
        if (model != "") {
            model = "." + model;
        }
        return this.props.model + "[" + index + "]" + model;
    }

    isModelValid(index: number, model: string) {
        var listItemModel = this.getListItemModel(index, model);

        return this.props.fieldSet.isModelValid(listItemModel);
    }

    removeModel(index: number, model: string) {
        this.props.fieldSet.removeModel(this.getListItemModel(index, model));
    }

    removeValidation(index: number, model: string) {
        this.props.fieldSet.removeValidation(this.getListItemModel(index, model));
    }

    removeItem(index: number) {
        console.log("remove item with index = " + index);
        var list: any[] = this.props.fieldSet.getModelValue(this.props.model);
        if (!list || list.length == 0) {
            return;
        }
        this.props.fieldSet.removeModel(this.props.model + "[" + index + "]");
    }

    setInitialModel(index: number, model: string, value: any, pristine: boolean, validationResult?: ValidationResult) {
        if (!model) {
            console.warn("Attribute model not set in list item FormComponent");
        }
        this.props.fieldSet.setInitialModel(this.getListItemModel(index, model), value, true, validationResult);
    }

    move(index: number, back: boolean) {
        if (back && index == 0) {
            return;
        } else if (!back && index == this.props.fieldSet.getModelValue(this.props.model).length - 1) {
            return;
        }

        var list: any[] = this.props.fieldSet.getModelValue(this.props.model);
        if (!list || list.length == 0) {
            return;
        }
        list = list.concat();
        list.splice(index, 0, list.splice(back ? index - 1 : index + 1, 1)[0]);
        this.props.fieldSet.updateModel(this.props.model, list, false, {errorName: null, pristine: false});
    }

    renderList() {
        var list: any[] = this.props.fieldSet.getModelValue(this.props.model);
        if (!list || list.length == 0) {
            return [];
        }
        var results = [];
        var index: number = 0;
        list.forEach(item => {
            results.push(<FormListItem key={this.props.key ? this.getListItemModel(index, this.props.key) : index}
                                       index={index}
                                       item={item}
                                       elements={this.props.children}
                                       removeModel={this.removeModel.bind(this, index)}
                                       onListItemUpdate={this.updateEntry.bind(this, index)}
                                       onRemoveItem={this.removeItem.bind(this, index)}
                                       onMoveItem={this.move.bind(this, index)}
                                       isModelValid={this.isModelValid.bind(this, index)}
                                       onListItemsUpdate={this.updateEntries.bind(this, index)}
                                       parentFieldSet={this.props.fieldSet}
                                       setInitialModel={this.setInitialModel.bind(this, index)}
                                       removeValidation={this.removeValidation.bind(this, index)}
            />);
            index++;
        });

        return results;

    }

    render() {
        return <span>{this.renderList()}</span>
    }
}

interface FormListItemProps {
    index?: number;
    item?: any;
    elements?: any,
    onListItemUpdate?: (model: string, value: any, pristine: boolean, validationResult: ValidationResult) => void;
    onRemoveItem?: () => void;
    onAddItem?: () => void;
    setInitialValidation?: (model: string, validationError: string, pristine: boolean) => void;
    setInitialModel: (model: string, value: any, pristine: boolean, validationResult: ValidationResult) => void;
    isModelValid: (model: string) => boolean;
    onListItemsUpdate: (kvps: KeyValue<any>[]) => void;
    onMoveItem: (back: boolean) => void;
    parentFieldSet?: FieldSet;
    removeModel?: (model: string) => void;
    removeValidation?: (model: string) => void;


}

export class FormListItem extends React.Component<FormListItemProps, {}> implements ListItemFieldSet {

    resetSubmitStatus(): void {
        this.props.parentFieldSet.resetSubmitStatus();
    }

    setInitialModel(model: string, value: any, pristine: boolean, validationResult?: ValidationResult) {
        this.props.setInitialModel(model, value, pristine, validationResult);
    }

    modelDidUpdate(model) {
        this.props.onRemoveItem();
    }

    removeValidation(model: string) {
        this.props.removeValidation(model);
    }

    isSubmitting(): boolean {
        return this.props.parentFieldSet.isSubmitting();
    }

    getStatus(): FieldSetStatus {
        return this.props.parentFieldSet.getStatus();
    }

    getFormError(): string {
        return this.props.parentFieldSet.getFormError();
    }

    removeModel(model: string) {
        this.props.removeModel(model);
    }

    updateModel(model, value, pristine, validationResult) {
        if (!model) {
            console.warn("Attribute model is not set on list item");
        }
        this.props.onListItemUpdate(model, value, pristine, validationResult);
    }

    updateModels(kvp: KeyValue<any>[]) {
        this.props.onListItemsUpdate(kvp);
    }

    isModelValid(model) {
        if (model == "" || model == null || typeof model == "undefined" || model.indexOf("[") == 0) {
            model = "";
        }
        return this.props.isModelValid(model);
    }

    removeCurrentItem() {
        this.props.onRemoveItem();
    }

    move(back: boolean) {
        this.props.onMoveItem(back);
    }

    addItem() {
        this.props.onAddItem();
    }


    getModelObject() {
        return this.props.item;
    }

    getModelValue(model: string): any {
        if (model == "" || model == null || typeof model == "undefined" || model.indexOf("$") == 0) {
            return this.props.item;
        } else {
            return _.get(this.props.item, model);
        }
    }

    componentDidMount() {
    }

    render() {
        return <span>{FormUtils.renderChildren(this.props.elements, this, null, this.props.index)}</span>
    }
}


export class ModelBinding<M> {

    fieldSet: FieldSet | ListItemFieldSet;
    model: string;


    constructor(fieldSet, model) {
        this.fieldSet = fieldSet;
        this.model = model;
    }

    getValue(): M {
        return this.fieldSet.getModelValue(this.model);
    }

    setValue(value: M) {
        this.fieldSet.updateModel(this.model, value, true);
    }

    remove() {
        this.fieldSet.updateModel(this.model, null, true);
    }

    removeCurrentItem(): void {
        this.fieldSet.removeCurrentItem();
    }
}

export class ListItemBinding<M> extends ModelBinding<M> {
    index: number;

    constructor(index, fieldSet, model) {
        super(fieldSet, model);
        this.index = index;
    }

    moveItem(back: boolean) {
        (this.fieldSet as ListItemFieldSet).move(back);
    }
}

export class ListModelBinding<M> extends ModelBinding<M[]> {

    addItem(item: M) {
        if (!this.getValue()) {
            this.fieldSet.updateModel(this.model, [item], true, {errorName: null, pristine: true});
        } else {
            var list = _.clone(this.getValue())
            list.push(item);
            this.fieldSet.updateModel(this.model, list, true, {errorName: null, pristine: true});
        }
    }

    removeFirst() {
        var list: any[] = _.clone(this.getValue())

        if (list && list.length > 0) {
            this.fieldSet.removeModel(this.model + "[0]");
        }
    }

    removeLast() {
        var list: any[] = _.clone(this.getValue())
        if (list && list.length > 0) {
            var index = list.length - 1;
            this.fieldSet.removeModel(this.model + "[" + index + "]");
        }

    }

    getLast(): M {
        var value = this.getValue();
        if (value == null || value.length == 0) {
            return null;
        }
        return value[value.length - 1];
    }

}

interface BindProps extends FormElement<any, HTMLElement> {
    render: (binding: ModelBinding<any>) => JSX.Element;
    binding?: ModelBinding<any>;
    model?: string;
    type?: string;
}

export class BindModel extends React.Component<BindProps, {}> {

    render() {
        return this.props.render(this.props.binding);
    }
}




// WEBPACK FOOTER //
// ./src/app/ui/form/FormList.tsx